import React from 'react';

import service1 from '../assets/images/service-icons-1.svg';
import service2 from '../assets/images/service-icons-2.svg';
import service3 from '../assets/images/service-icons-3.svg';
import service4 from '../assets/images/service-icons-4.svg';
import service5 from '../assets/images/service-icons-5.svg';
import service6 from '../assets/images/service-icons-6.svg';
import contactIcon from '../assets/images/btn-icon-5.svg';

const ServicesSection = () => {
  return (
    <section className="our-services py-5">
      <div className="container frame-wrapper">
        <div className="frame text-center">
          <div className="title-section mb-4">
            <h2 className="text-wrapper mb-3">Our Services</h2>
            <p className="div">
              Complete home maintenance services to keep your property in perfect condition, especially designed for
              NRIs and homeowners in Kerala.
            </p>
          </div>

          <div className="row justify-content-center g-4 service-cards">
            {[ // Services data array for reuse
              { icon: service1, title: 'Home Cleaning', desc: 'Enjoy a spotless home with regular or one-time cleaning services.' },
              { icon: service2, title: 'Deep Cleaning', desc: 'Tackle dirt and grime with intensive cleaning for a refreshed home.' },
              { icon: service3, title: 'Plumbing', desc: 'Fix leaks, unclog drains, and keep your water systems running smoothly.' },
              { icon: service4, title: 'Electrical Repairs', desc: 'Safe, reliable fixes for all your electrical issues. Power up with expert care.' },
              { icon: service5, title: 'Painting Services', desc: 'Give your home a fresh look with professional painting services.' },
              { icon: service6, title: 'Pest Control', desc: 'Protect your home from pests with effective and safe treatments.' }
            ].map((service, index) => (
              <div className="col-12 col-md-6 col-lg-4" key={index}>
                <div className="service-card h-100">
                  <div className="service-card-content">
                    <div className="inner-wrapper">
                      <img className="service-icons" src={service.icon} alt={service.title} />
                    </div>
                    <div className="text-content mt-3">
                      <div className="text-wrapper-2">{service.title}</div>
                      <p className="p">{service.desc}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <button className="primary-btn-medium d-inline-flex align-items-center">
              <span className="primary-button">Contact Us</span>
              <img className="btn-icon ms-2" src={contactIcon} alt="Contact Us" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
